import { Singleton } from 'annotation';
import environment from 'environment';

import ProxyService from './Proxy';
import EntityAware from '../entity/EntityAware';
import Merchant from "../entity/Merchant";
import UserMerchant from "../entity/UserMerchant";
import DeviceMerchant from "../entity/DeviceMerchant";
import Parameter from "./Parameter";

@Singleton
export default class MerchantService extends ProxyService {

    public api: string = environment.MERCHANT_API;

    public serializer: EntityAware = Merchant;

    public serializerUser: EntityAware = UserMerchant;

    public serializerDevice: EntityAware = DeviceMerchant;

    public findMerchantById(id: string): Promise<any> {
        const parameter = new Parameter()
            .setUrl(this.api + `/${id}`).serializeData(this.serializer);
        return super.request(parameter);
    }

    public updateMerchantCustom(merchant: Merchant): Promise<any> {
        const parameter = new Parameter(merchant).setMethod(Parameter.methods.PUT)
            .setUrl(this.api + `/${merchant.id}`)
            .serializeData(this.serializer);
        return super.request(parameter);
    }

    public findUserMerchant(kode: string): Promise<any> {
        const parameter = new Parameter()
            .setUrl(this.api + `/user/${kode}`).serializeData(this.serializerUser);
        return super.request(parameter);
    }

    public saveUserMerchant(param: any): Promise<any> {
        const parameter = new Parameter(param).setMethod(Parameter.methods.POST)
            .setUrl(this.api + `/user`).serializeData(this.serializerUser);
        return this.request(parameter);
    }

    public deleteUserMerchant(id: string): Promise<any> {
        const parameter = new Parameter().setMethod(Parameter.methods.DELETE)
            .setUrl(this.api + `/user/remove/${id}`);

        return this.request(parameter);
    }

    public updateStatusUser(param: any): Promise<any> {
        const parameter = new Parameter(param).setMethod(Parameter.methods.POST)
            .setUrl(this.api + `/user/status`).serializeData(this.serializerUser);
        return this.request(parameter);
    }

    public findDeviceMerchant(kode: string): Promise<any> {
        const parameter = new Parameter()
            .setUrl(this.api + `/device/${kode}`).serializeData(this.serializerDevice);
        return super.request(parameter);
    }

    public deleteDeviceMerchant(id: string): Promise<any> {
        const parameter = new Parameter().setMethod(Parameter.methods.DELETE)
            .setUrl(this.api + `/device/remove/${id}`);

        return this.request(parameter);
    }

    public updateStatusDevice(param: any): Promise<any> {
        const parameter = new Parameter(param).setMethod(Parameter.methods.POST)
            .setUrl(this.api + `/device/status`).serializeData(this.serializerDevice);
        return this.request(parameter);
    }

}
